import diacritics from 'diacritics';
import { isNullOrUndefined } from './null-safety.js';

export function isNullOrUndefinedOrEmpty(
    str: string | null | undefined,
): str is null | undefined | '' {
  if(isNullOrUndefined(str)) {
    return true;
  }

  return str.length <= 0;
}

export function isNotNullOrUndefinedOrEmpty(
    str: string | null | undefined,
): str is string {
  return !isNullOrUndefinedOrEmpty(str);
}

const SAFE_FILENAME_ALPHABET = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789_';

export function isSafeFilename(str: string): boolean {
  for(const c of str) {
    if(!SAFE_FILENAME_ALPHABET.includes(c)) {
      return false;
    }
  }

  return true;
}

export function toSafeFilename(str: string): string {
  const dirty = diacritics.remove(str);

  const result = [];
  for(const c of dirty) {
    if(c === ' ' || c === '-') {
      result.push('_');
    }
    else if(SAFE_FILENAME_ALPHABET.includes(c)) {
      result.push(c);
    }
  }

  return result.join('');
}
